var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRightDoubleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.7 11.297a.948.948 0 01-.274-.7c0-.284.091-.517.275-.7l3.875-3.9L.7 2.097a.978.978 0 01-.288-.687A.93.93 0 01.7.697a.948.948 0 01.7-.275c.283 0 .516.092.7.275l4.6 4.6c.1.1.17.208.213.325.042.117.062.242.062.375s-.021.258-.062.375a.867.867 0 01-.213.325l-4.6 4.6a.979.979 0 01-.687.288.93.93 0 01-.713-.288zm6.6 0a.948.948 0 01-.274-.7c0-.284.091-.517.275-.7l3.875-3.9-3.875-3.9a.978.978 0 01-.288-.687A.93.93 0 017.3.697.948.948 0 018 .422c.283 0 .516.092.7.275l4.6 4.6c.1.1.17.208.213.325.042.117.062.242.062.375s-.021.258-.063.375a.887.887 0 01-.212.325l-4.6 4.6a.979.979 0 01-.687.288.93.93 0 01-.713-.288z",
    fill: "#A8A9AC"
  })));
}

export default SvgIconRightDoubleArrow;